var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-invites',{ref:"actionInvites",attrs:{"participants":_vm.participants,"selected-participants":_vm.selectedParticipants,"api":_vm.getApiForInvite}})
}
var staticRenderFns = []

export { render, staticRenderFns }